<template>
  <div id="app">
    <Calculator />
  </div>
</template>

<script>
import Calculator from '@/components/Calculator.vue';

export default {
  name: 'App',
  components: {
    Calculator,
  },
};
</script>

<style lang="scss">
.hwh-calculator{
  margin: 0 auto;
  max-width: 1140px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #656565;
  font-family: "Helvetica Nueue", Helvetica, sans-serif;
  font-weight: 300;
  font-size: 14px;
  line-height: 1.3;
  &-header{
    img{
      display: block;
      width: 100%;
    }
  }
  div{
    box-sizing: border-box;
  }
}
</style>
